import { Component, OnInit } from '@angular/core';
import { lang_dispatch } from 'app/idiomas/i18n/dispatch/dispatch.lang';
import { lang_requerimientos } from 'app/idiomas/i18n/requerimientos/requerimientos.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import Swal from 'sweetalert2';
import {TranslateService} from '@ngx-translate/core';
import { FuseConfigService } from '@fuse/services/config.service';

@Component({
  selector: 'app-new-rtdemo',
  templateUrl: './new-rtdemo.component.html',
  styleUrls: ['./new-rtdemo.component.scss']
})
export class NewRTDemoComponent implements OnInit {

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private _fuseConfigService: FuseConfigService,
  ) {
    lang_requerimientos.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_dispatch.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this._fuseConfigService.config = {
      layout: {
        navbar   : {hidden: true },
        toolbar  : {hidden: true },
        footer   : {hidden: false },
        sidepanel: {hidden: true }
      }
    };

  }

}
